import { ActionAlertProvider } from "@suraasa/placebo-ui"
import { Outlet } from "react-router-dom"

import BottomNavigationBar from "@/components/navigation-bar/bottom-navigation-bar"
import TopNavigationBar from "@/components/navigation-bar/top-navigation-bar"
import { AuthProvider } from "@/context/auth-context"
import { GlobalContextProvider } from "@/context/global-context"

const RootLayout = () => {
  return (
    <AuthProvider>
      <GlobalContextProvider>
        <ActionAlertProvider>
          <TopNavigationBar />
          <Outlet />
          <BottomNavigationBar />
        </ActionAlertProvider>
      </GlobalContextProvider>
    </AuthProvider>
  )
}

export default RootLayout
